function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
}

class TestimonialOpener extends HTMLElement {
  constructor() {
    super();

    // Bind methods to the component's context
    this.handleClick = this.handleClick.bind(this);
    this.closeModal = this.closeModal.bind(this);

    // Create a unique ID for each modal instance (to avoid conflicts between multiple openers)
    this.modalId = `modal-${Math.random().toString(36).substring(2, 9)}`;
  }

  connectedCallback() {
    // Add event listener to open the modal (on the custom element itself)
    this.addEventListener("click", this.handleClick);
  }

  handleClick() {
    // Check if the modal already exists; if not, create and append it to document.body
    if (!document.getElementById(this.modalId)) {
      this.createModal();
    }

    // Show the modal
    const modal = document.getElementById(this.modalId);
    modal.classList.add("modal--is-active");
  }

  createModal() {
    // Create a modal element and append it to the document body
    const modal = document.createElement("div");
    modal.id = this.modalId;
    modal.classList.add("modal");

    // Add the modal's inner HTML
    modal.innerHTML = `
        <div class="modal__inner flex items-center justify-center cursor-pointer">
            <div class="modal-content !p-0">
                <span class="close-button modal__close">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" class="layer"/></svg>
                </span>
                <div class="video-container"></div>
            </div>
        </div>
      `;

    // Append the modal to document.body
    document.body.appendChild(modal);

    // Attach event listener to close the modal
    modal
      .querySelector(".close-button")
      .addEventListener("click", this.closeModal);
    modal
      .querySelector(".modal__inner")
      .addEventListener("click", this.closeModal);
    modal
      .querySelector(".modal-content")
      .addEventListener("click", (e) => e.stopPropagation());

    // Get the template content from the opener and inject it into the modal
    const template = this.querySelector("template");
    if (template) {
      const videoContent = template.content.cloneNode(true);
      modal.querySelector(".video-container").appendChild(videoContent);
    }

    if (template.hasAttribute("data-video-height")) {
      modal.setAttribute(
        "data-video-height",
        template.getAttribute("data-video-height")
      );
    } else {
      modal.removeAttribute("data-video-height");
    }
  }

  closeModal() {
    // Hide the modal when the close button is clicked
    const modal = document.getElementById(this.modalId);
    if (modal) {
      modal.classList.remove("modal--is-active");
    }
    pauseAllMedia();
  }

  disconnectedCallback() {
    // Clean up event listeners when the component is removed
    this.removeEventListener("click", this.handleClick);

    const modal = document.getElementById(this.modalId);
    if (modal) {
      modal
        .querySelector(".close-button")
        .removeEventListener("click", this.closeModal);
    }
  }
}

// Define the custom element
customElements.define("testimonial-opener", TestimonialOpener);
